import {Injectable} from '@angular/core';
import {Constants} from '../../../../../common/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {

  public getBrowserVersion(): string {
    const {userAgent} = navigator;
    let matchAgentData = this.matchAgentData(userAgent);
    matchAgentData = this.processMatchData(userAgent, matchAgentData);
    return matchAgentData.join(Constants.HYPHEN);
  }

  private matchAgentData(userAgent: string): string[] {
    const match = /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i.exec(userAgent) || [];

    if (/trident/i.test(match[1])) {
      const tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return [`ie-${tem[1] || ''}`];
    }

    if (match[1] === 'Chrome') {
      const tem = /\b(OPR|Edge)\/(\d+)/.exec(userAgent);
      if (tem !== null) {
        return [tem.slice(1).join(Constants.HYPHEN).replace('OPR', 'Opera')];
      }
    }

    return match[2] ? [match[1], match[2]] : ['unknown', '-?'];
  }

  private processMatchData(userAgent: string, matchData: string[]): string[] {
    const tem = /version\/(\d+)/i.exec(userAgent);
    if (tem !== null) {
      matchData.splice(1, 1, tem[1]);
    }
    return matchData;
  }

}
